import { render, staticRenderFns } from "./ChangeFormula.vue?vue&type=template&id=2402575a&"
import script from "./ChangeFormula.vue?vue&type=script&lang=js&"
export * from "./ChangeFormula.vue?vue&type=script&lang=js&"
import style0 from "./ChangeFormula.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports